export default "__VITE_ASSET__Dn1GvE$U__"